{
  "version": 1,
  "asset_id": "0ab1a21a-3822-4154-a23f-44f76327d4e1",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0ab1a21a-3822-4154-a23f-44f76327d4e1/lynx-gsc-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0ab1a21a-3822-4154-a23f-44f76327d4e1/lynx-gsc-1280.avif",
  "original_filename": "lynx-gsc-1280.avif",
  "size": 34173,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:59Z"
}
